module.exports = __webpack_public_path__ + "docs/cookies.47cacedb1a66824a53a74b3bec053312.html";